import React, { useState, useEffect } from 'react';
import { useContact } from '../context/ContactContext';
import './CallPopup.css';

function CallPopup() {
  const { contactSettings } = useContact();
  const tfn = contactSettings?.tfn || '+1-888-859-0441';
  const tfnClean = tfn.replace(/[^0-9+]/g, '');
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if user already dismissed in this session
    if (sessionStorage.getItem('callPopupDismissed')) {
      return;
    }
    // Show after 4 seconds
    const timer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('callPopupDismissed', '1');
    setTimeout(() => setVisible(false), 300);
  };

  if (!visible) return null;

  return (
    <div className={`call-popup ${dismissed ? 'call-popup-exit' : 'call-popup-enter'}`}>
      <button className="call-popup-close" onClick={handleDismiss} aria-label="Close">
        ✕
      </button>
      <div className="call-popup-inner">
        <div className="call-popup-icon">
          <div className="call-popup-ring" />
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="call-popup-phone-svg">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="call-popup-content">
          <p className="call-popup-text">
            <strong>Call our Travel Experts</strong> 24/7. Say <span className="call-popup-code">CALL10</span> to save:
          </p>
          <a href={`tel:${tfnClean}`} className="call-popup-number">{tfn}</a>
          <a href="/travel-assistance" className="call-popup-learn">Learn more</a>
        </div>
      </div>
    </div>
  );
}

export default CallPopup;
